export default __webpack_public_path__ + "static/media/70.d69fd6a0.jpg";